export enum Route {
    CartDelete = "cart/delete",
    CartGet = "cart/get",
    CartGetOrCreate = "cart/get-or-create",
    CartSubmit = "cart/submit",
    CartCreateWithData = "cart/create-cart-with-data",
    DocumentExists = "cart/document-exists",
    DocumentsGet = "cart/get-documents",
    DocumentsAdd = "cart/add-documents",
    DocumentsRemove = "cart/remove-documents",
    DocumentsSync = "cart/sync-documents",
    CustomDocumentsUpload = "cart/upload-custom-documents",
    CustomDocumentsRemove = "cart/remove-custom-documents",
    CustomDocumentsGet = "cart/get-custom-documents",
    PredefinedDocumentsSync = "cart/sync-predefined-documents",
    PredefinedDocumentsGet = "cart/get-predefined-documents",
    PredefinedDocumentsAdd = "cart/add-predefined-documents",
    PredefinedDocumentsRemove = "cart/remove-predefined-documents",
    MailSizeGet = "cart/get-mail-size",
    MailSettingsGet = "cart/get-mail-settings",
    MailSettingsSet = "cart/set-mail-settings",
    CustomerSet = "cart/set-customer",
    RecipientsSet = "cart/set-recipients",
}